import GlobalPixel from './GlobalPixel';

export default GlobalPixel;
